import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MenuCard from "../../component/MenuCard";
import VegIcon from "../../Assets/vegIcon.png"
import NonVegIcon from "../../Assets/nonVegIcon.png"
import '../../component/ListItem/listItem.css'
import './cartPage.css'
import LoginPage from "../Login";
import ItemStatus from "../../component/MenuCard/ItemStatus";
import { updateStatusAPI } from "../../redux/action";
import { pathUpdateWithExtention } from "../../Utills/utils";
import { diet } from "../../Utills/enums";
import { ButtonLoader } from "../../component/common/Loader";


const StatusCartPage = () => {

    const { restaurantId, locationId, currency = '₹' } = useParams()

    const menuList = useSelector((state) => state?.user?.menu);
    const cart = useSelector((state) => state?.admin?.updateStatus);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (!Object.values(cart).length) {
            // If cart is empty, redirect to menu-status page
            navigate(pathUpdateWithExtention('menu-status'));
        }
    }, []);

    const cartItems = () => {
        const items = []
        Object.values(cart).map(c => {
            let item = menuList.categories.find(cat => cat.categoryId === c.selectedTabId)
                .items.find(item => item.menuId === c.menuId);
            items.push({ ...item, selectedTabId: c.selectedTabId, selected: c.isAvailable })
        })
        // return items ? items : <div> All cought </div>
        return items;
    };

    const itemList = cartItems();
    // const totalPrice = getTotalPrice()

    const handleStatusClick = () => {

        if (loading) return;   // prevent multiple clicks
        setLoading(true);

        try {
            if (cart) {
                dispatch(updateStatusAPI(cart));
                // dispatch(updateStatusAPI({ restaurantId, locationId, status: 'pending' }));
            }
            // You can optionally show a success toast here
        } catch (err) {
            console.error("Failed to update status:", err);
            // You can optionally show an error toast here

        } finally {
            setLoading(false);
        }
    }

    return (<div className="cart-container">
        <div className="cartPage lrSpace">
            <h2>Status Summary</h2>
            <ul className="no-bullets">
                {/* todo: on click animation */}
                {itemList.length === 0 ? <div> No Item to show</div> : itemList.map((val) =>
                    val.menuId != undefined ? <MenuCard
                        key={val.menuId}
                        menuId={val.menuId}
                        src={val.imageUrl}
                        title={val.foodName}
                        description={val.description}
                        price={val.price}
                        dietIcon={diet[val.foodTypeId] === 'Veg' || diet[val.foodTypeId] === 'Vegan' ? VegIcon : NonVegIcon}
                        tab={val?.selectedTabId}
                        unit={val}
                        ActionComponent={ItemStatus}
                        isAvailable={val.selected}
                    /> : <div></div>
                )}
            </ul>
            <div className="btnContainer">
                <button onClick={handleStatusClick}
                    style={{ ...styles.addButton }}
                    className="spinner-btn"
                    disabled={loading} >
                    {loading ? <ButtonLoader label="Updating status..." /> : "Update Status"}
                </button>
            </div>

            {/* <div>Offers and Benifits</div> */}
            {/* <div className="payTitle">Payment Summary</div>
        <div className="priceRow">
            <div className="yyy">Subtotal</div>
            <div className="zzz"><b>{currency} {totalPrice}</b></div>
        </div>
        <div className="priceRow theameColor">
            <div className="yyy">Discount</div>
            <div className="zzz">{currency} 50</div>
        </div>
        <div className="priceRow">
            <div className="yyy">Service Charges</div>
            <div className="zzz">{currency} 20</div>
        </div>
        <div className="priceRow">
            <div className="yyy"><b>Total amount</b></div>
            <div className="zzz"><b>{currency} {totalPrice + 20 - 50}</b></div>
        </div> */}

        </div>
    </div>)
}

const styles = {
    addButton: {
        marginTop: '10px',
        padding: '10px 20px',
        backgroundColor: '#0078d4',
        color: '#fff',
        border: 'none',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
    },
    spinner: {
        width: '16px',
        height: '16px',
        border: '2px solid rgba(255, 255, 255, 0.5)',
        borderTop: '2px solid #fff',
        borderRadius: '50%',
        marginRight: '8px',
        animation: 'spin 0.6s linear infinite'
    },

};

export default StatusCartPage;
